import { OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditDescComponent } from '../edit-desc/edit-desc.component';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
var BusinessDescriptionComponent = /** @class */ (function () {
    function BusinessDescriptionComponent(_editDescDialog, _toggleService, snackBar) {
        this._editDescDialog = _editDescDialog;
        this._toggleService = _toggleService;
        this.snackBar = snackBar;
        this.editModeSet = false;
    }
    BusinessDescriptionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    };
    Object.defineProperty(BusinessDescriptionComponent.prototype, "hasContent", {
        get: function () {
            return this.business && !!this.business.description;
        },
        enumerable: true,
        configurable: true
    });
    BusinessDescriptionComponent.prototype.openEditDescDialog = function () {
        var DATA = { business: this.business };
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = DATA;
        dialogConfig.width = '100%';
        var DIALOG_REF = this._editDescDialog.open(EditDescComponent, dialogConfig);
        this._handleModalClose(DIALOG_REF);
    };
    /**
     * listens for dialog close event. Opens snackbar if necessary
     * @param {MatDialogRef<any>} dialogRef
     * @private
     */
    BusinessDescriptionComponent.prototype._handleModalClose = function (dialogRef) {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogRef.afterClosed().subscribe(function (success) {
            if (success === null) {
                return;
            }
            if (success) {
                _this.snackBar.open('Business Description', 'Updated', {
                    duration: 3000
                });
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return BusinessDescriptionComponent;
}());
export { BusinessDescriptionComponent };
